import first from "lodash/first";
import type { FunctionComponentWithRef } from "react";
import { graphql, useFragment } from "react-relay";

import { withHighlightedHeadline } from "scmp-app/components/content/content-item-render/highlight/hoc";
import { useContentItemProviders } from "scmp-app/components/content/content-item-render/hooks";
import type { ContentItemRenderVariantProps } from "scmp-app/components/content/content-item-render/types";
import type { homeAroundMorningStudioSecondaryContentItemContent$key } from "scmp-app/queries/__generated__/homeAroundMorningStudioSecondaryContentItemContent.graphql";

import {
  Container,
  Content,
  Headline,
  SponsorContainer,
  SponsorName,
  SponsorType,
  StyledEntityLink,
} from "./styles";

export type Props = ContentItemRenderVariantProps & {
  reference: homeAroundMorningStudioSecondaryContentItemContent$key;
};

const Component: FunctionComponentWithRef<Props, HTMLDivElement> = ({
  className,
  onClick,
  ref: forwardReference,
  reference: reference_,
}) => {
  const content = useFragment(
    graphql`
      fragment homeAroundMorningStudioSecondaryContentItemContent on Content {
        entityId
        urlAlias
        topics {
          sponsor {
            name
            type
          }
        }
        ...entityLink
        ...hooksContentItemProvidersContent @arguments(withHeadline: true)
      }
    `,
    reference_,
  );
  const providers = useContentItemProviders(content);

  const sponsor = first(content?.topics)?.sponsor;
  const sponsorName = sponsor?.name;
  const sponsorType = sponsor?.type;

  return (
    <Container className={className} ref={forwardReference}>
      <StyledEntityLink
        onClick={() => onClick?.(content.entityId, content.urlAlias)}
        reference={content}
      >
        <Content>
          <Headline>
            {providers.headline({
              hideTooltip: true,
              preferSocialHeadline: true,
              skipHeadlineSponsorStyle: true,
            })}
          </Headline>
        </Content>
      </StyledEntityLink>
      <SponsorContainer>
        <SponsorType>{sponsorType}</SponsorType>
        <SponsorName>{sponsorName}</SponsorName>
      </SponsorContainer>
    </Container>
  );
};

Component.displayName = "ContentItemHomeAroundMorningStudioSecondary";

export const ContentItemHomeAroundMorningStudioSecondary = withHighlightedHeadline(Component);
